import { render, staticRenderFns } from "./BufferClassTutoring.vue?vue&type=template&id=080b0944&scoped=true"
import script from "./BufferClassTutoring.vue?vue&type=script&lang=js"
export * from "./BufferClassTutoring.vue?vue&type=script&lang=js"
import style0 from "./BufferClassTutoring.vue?vue&type=style&index=0&id=080b0944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080b0944",
  null
  
)

export default component.exports